/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import type { SVGProps } from "react";

import { useLocale } from "@superweb/intl";
import { icons } from "@superweb/ui";
import { useId } from "react-aria";

export const Alice = (props: SVGProps<SVGSVGElement>) => {
  const id = useId();

  return (
    <svg width="28" height="28" fill="none" {...props}>
      <g clipPath={`url(#a-${id})`}>
        <g filter={`url(#b-${id})`}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.995 25.667c6.443 0 11.667-5.223 11.667-11.666 0-6.444-5.224-11.667-11.667-11.667-6.444 0-11.667 5.223-11.667 11.667 0 6.443 5.223 11.666 11.667 11.666Zm-6.306-7.914c-1.427-2.542 3.433-11.22 6.31-11.22s7.729 8.68 6.301 11.22c-1.427 2.54-11.184 2.542-12.611 0Z"
            fill="#21201F"
          />
        </g>
        <g clipPath={`url(#c-${id})`}>
          <foreignObject
            x="-1263.65"
            y="-1263.65"
            width="2527.29"
            height="2527.29"
            transform="matrix(0 .0123 -.0123 0 13.995 14)"
          >
            <div
              css={{
                backgroundImage:
                  "conic-gradient(from 90deg,#daa5fe 0deg,#c7a2ff 30.6398deg,#14cdff 72deg,#ff43c9 117.349deg,#ffcf3f 216deg,#fcabfe 306.346deg,#daa5fe 360deg);height:100%;width:100%;opacity:1",
              }}
            />
          </foreignObject>
        </g>
        <path
          clipRule="evenodd"
          d="M13.995 25.666c6.443 0 11.667-5.223 11.667-11.666 0-6.444-5.224-11.667-11.667-11.667C7.55 2.333 2.328 7.556 2.328 14c0 6.443 5.223 11.666 11.667 11.666Z"
        />
        <foreignObject x="-8.398" y="-8.4" width="44.801" height="44.8">
          <div
            css={{
              backdropFilter: "blur(5.25px)",
              clipPath: `url(#d-${id})`,
              height: "100%",
              width: "100%",
            }}
          />
        </foreignObject>
        <rect
          x="2.102"
          y="2.1"
          width="23.8"
          height="23.8"
          rx="11.9"
          fill="#fff"
          fillOpacity=".01"
        />
        <path
          d="M14.004 6.533c-2.877 0-7.737 8.678-6.31 11.22 1.428 2.541 11.184 2.54 12.611 0 1.428-2.54-3.424-11.22-6.3-11.22Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id={`c-${id}`}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.995 25.666c6.443 0 11.667-5.223 11.667-11.666 0-6.444-5.224-11.667-11.667-11.667C7.55 2.333 2.328 7.556 2.328 14c0 6.443 5.223 11.666 11.667 11.666Z"
          />
        </clipPath>
        <clipPath id={`d-${id}`} transform="translate(8.398 8.4)">
          <rect x="2.102" y="2.1" width="23.8" height="23.8" rx="11.9" />
        </clipPath>
        <clipPath id={`a-${id}`}>
          <path fill="#fff" d="M0 0h28v28H0z" />
        </clipPath>
        <filter
          id={`b-${id}`}
          x="-.612"
          y="-.606"
          width="29.212"
          height="29.213"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1.47" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0.964706 0 0 0 0 0.745098 0 0 0 0 0.890196 0 0 0 1 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_35434_87817"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_35434_87817"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const ArrowInlineEnd = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ArrowLeft {...props} />
  ) : (
    <icons.ArrowRight {...props} />
  );
};

export const ArrowInlineStart = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ArrowRight {...props} />
  ) : (
    <icons.ArrowLeft {...props} />
  );
};

export const ChevronInlineEnd = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronLeft {...props} />
  ) : (
    <icons.ChevronRight {...props} />
  );
};

export const ChevronInlineEndFillM = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronLeftFillM {...props} />
  ) : (
    <icons.ChevronRightFillM {...props} />
  );
};

export const ChevronInlineEndL = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronLeftL {...props} />
  ) : (
    <icons.ChevronRightL {...props} />
  );
};

export const ChevronInlineEndFillL = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronLeftFillL {...props} />
  ) : (
    <icons.ChevronRightFillL {...props} />
  );
};

export const ChevronInlineStart = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronRight {...props} />
  ) : (
    <icons.ChevronLeft {...props} />
  );
};

export const ChevronInlineStartFillM = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronRightFillM {...props} />
  ) : (
    <icons.ChevronLeftFillM {...props} />
  );
};

export const ChevronInlineStartL = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronRightL {...props} />
  ) : (
    <icons.ChevronLeftL {...props} />
  );
};

export const ChevronInlineStartFillL = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronRightFillL {...props} />
  ) : (
    <icons.ChevronLeftFillL {...props} />
  );
};

export const CornerInlineEnd = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronLeft {...props} />
  ) : (
    <icons.ChevronRight {...props} />
  );
};

export const CornerInlineStart = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();
  return textInfo.direction === "rtl" ? (
    <icons.ChevronRight {...props} />
  ) : (
    <icons.ChevronLeft {...props} />
  );
};

export const DownPrice = (props: SVGProps<SVGSVGElement>) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m1 5.79 5.15 5.71L11 5.79l-2.716.5-.531-2.79h-3.36l-.677 2.79L1 5.79ZM4.514 3h3.144l-.191-1h-2.71l-.243 1Zm.364-1.5.243-1h2.06l.19 1H4.878Z"
      clipRule="evenodd"
    />
  </svg>
);

export const FireFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="41" height="41" fill="none" viewBox="0 0 41 41" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.083 12.209c1.556-2.791 4.167-7.5 5.834-10h1.666c2.994 2.993 6.147 6.93 8.216 10.523 2.06 3.578 3.451 7.411 3.451 11.144 0 7.637-5.833 13.333-11.667 13.333l-.833-1.667c2.5-.833 4.167-3.333 4.167-6.666 0-4.4-4.3-9.25-6.667-11.667-2.368 2.417-6.667 7.5-6.667 11.667 0 3.333 2.5 5.833 4.167 6.666l-.833 1.667c-5.834 0-11.667-5.696-11.667-13.333 0-7.24 4.126-13.28 6.667-16.667h1.666z"
      clipRule="evenodd"
    />
  </svg>
);

export const SumOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M8.82617 17.3091C9.03353 17.436 9.28744 17.4995 9.58789 17.4995H14.7612C15.0828 17.4995 15.3346 17.4106 15.5166 17.2329C15.7028 17.0552 15.7959 16.8245 15.7959 16.541C15.7959 16.2533 15.7028 16.0226 15.5166 15.8491C15.3346 15.6756 15.0828 15.5889 14.7612 15.5889H10.8257V15.5127L13.4092 13.0117C13.5869 12.8636 13.7202 12.7007 13.8091 12.5229C13.9022 12.341 13.9487 12.1527 13.9487 11.958C13.9487 11.7676 13.9022 11.5814 13.8091 11.3994C13.7202 11.2174 13.5869 11.0524 13.4092 10.9043L10.832 8.42236V8.34619H14.7612C15.0871 8.34619 15.341 8.25944 15.5229 8.08594C15.7049 7.9082 15.7959 7.67757 15.7959 7.39404C15.7959 7.10628 15.7049 6.87565 15.5229 6.70215C15.341 6.52441 15.0871 6.43555 14.7612 6.43555H9.58789C9.29167 6.43555 9.03988 6.49902 8.83252 6.62598C8.62516 6.75293 8.46647 6.91797 8.35645 7.12109C8.25065 7.32422 8.19775 7.54215 8.19775 7.7749C8.19775 7.99072 8.24854 8.20866 8.3501 8.42871C8.45166 8.64876 8.60612 8.84342 8.81348 9.0127L11.8667 11.9009V11.9897L8.81348 14.9224C8.60189 15.0916 8.44531 15.2863 8.34375 15.5063C8.24642 15.7264 8.19775 15.9443 8.19775 16.1602C8.19775 16.3929 8.25065 16.6108 8.35645 16.814C8.46647 17.0171 8.62305 17.1821 8.82617 17.3091Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C14.1217 4 16.1566 4.84285 17.6569 6.34315C19.1571 7.84344 20 9.87827 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315Z"
      fill="currentColor"
    />
  </svg>
);

export const UpPrice = (props: SVGProps<SVGSVGElement>) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1 6.21 6.15.5 11 6.21l-2.716-.5-.531 2.79h-3.36l-.677-2.79L1 6.21ZM4.514 9h3.144l-.191 1h-2.71l-.243-1Zm.364 1.5.243 1h2.06l.19-1H4.878Z"
      clipRule="evenodd"
    />
  </svg>
);

export const FolderWithFile = (props: SVGProps<SVGSVGElement>) => (
  <svg width="17" height="17" viewBox="0 0 17 17" {...props}>
    <path d="M4.442 11.172h4.165v1.334H4.442v-1.334Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 1.834c-.736 0-1.333.597-1.333 1.333v2.396c-.736 0-1.333.597-1.333 1.334v6.936c0 .737.597 1.334 1.333 1.334h10.667c.736 0 1.333-.597 1.333-1.334v-5c0-.736-.597-1.333-1.333-1.333V3.167c0-.736-.597-1.333-1.333-1.333h-8Zm8 5.666H8.807L7.54 6.027a1.333 1.333 0 0 0-1.01-.464H4.5V3.167h8V7.5Zm-5.972-.603h-3.36v6.936h10.666v-5H8.807c-.389 0-.758-.169-1.011-.463L6.528 6.897Z"
      fill="currentColor"
    />
  </svg>
);

export const Money = (props: SVGProps<SVGSVGElement>) => (
  <svg width="17" height="17" viewBox="0 0 17 17" {...props}>
    <path
      d="m13.059 3.503.407 2.447h1.352l-.546-3.28a.803.803 0 0 0-1.09-.613c-.548.218-1.271.366-2.14.48-.728.095-1.522.162-2.361.233l-.473.04c-1.99.17-4.204.39-5.98 1.113a.798.798 0 0 0-.479.912l.246 1.115h1.366L3.15 5c1.491-.513 3.325-.704 5.17-.862l.464-.039a54.53 54.53 0 0 0 2.43-.24c.651-.085 1.28-.195 1.844-.356ZM5.84 12.833V9.167h1.334v3.666H5.84ZM10.84 13.116h2.334v-1.333H10.84v1.333ZM5.29 9.95a.783.783 0 1 1-1.567 0 .783.783 0 0 1 1.567 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.84 7.967a.8.8 0 0 1 .8-.8h11.837a.8.8 0 0 1 .8.8v6.4a.8.8 0 0 1-.8.8H2.64a.8.8 0 0 1-.8-.8v-6.4Zm1.334.533v5.333h10.77V8.5H3.174Z"
      fill="currentColor"
    />
  </svg>
);

export const ParametersOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 4c.439 0 .85 0 1.162.021.33.023.66.072.986.207a3 3 0 0 1 1.624 1.624c.135.326.184.656.207.986l.009.162H22v2h-2.012l-.01.162c-.022.33-.071.66-.206.986a3 3 0 0 1-1.624 1.624 3.073 3.073 0 0 1-.986.207C16.85 12 16.44 12 16 12c-.439 0-.85 0-1.162-.021a3.072 3.072 0 0 1-.986-.207 3 3 0 0 1-1.624-1.624 3.07 3.07 0 0 1-.207-.986A6.416 6.416 0 0 1 12.012 9H2V7h10.012l.01-.162c.022-.33.071-.66.206-.986a3 3 0 0 1 1.624-1.624c.326-.135.656-.184.986-.207C15.15 4 15.56 4 16 4Zm-1.026 2.017c-.228.015-.315.042-.357.06a1 1 0 0 0-.54.54c-.018.042-.045.129-.06.357C14 7.21 14 7.52 14 8s0 .79.017 1.026c.015.228.042.315.06.357a1 1 0 0 0 .54.54c.042.018.129.045.357.06C15.21 10 15.52 10 16 10s.79 0 1.026-.017c.228-.015.315-.042.357-.06a1 1 0 0 0 .54-.54c.018-.042.045-.129.06-.357C18 8.79 18 8.48 18 8s0-.79-.017-1.026c-.015-.228-.042-.315-.06-.357a1 1 0 0 0-.54-.54c-.042-.018-.129-.045-.357-.06A16.908 16.908 0 0 0 16 6c-.48 0-.79 0-1.026.017ZM4.012 15H2v2h2.012l.01.162c.022.33.071.66.206.986a3 3 0 0 0 1.624 1.624c.326.135.656.184.986.207C7.15 20 7.56 20 8 20c.438 0 .85 0 1.162-.021.33-.023.66-.072.986-.207a3 3 0 0 0 1.624-1.624c.135-.326.184-.656.207-.986l.009-.162H22v-2H11.988a6.928 6.928 0 0 0-.01-.162 3.072 3.072 0 0 0-.206-.986 3 3 0 0 0-1.624-1.624 3.07 3.07 0 0 0-.986-.207C8.85 12 8.44 12 8 12c-.439 0-.85 0-1.162.021a3.07 3.07 0 0 0-.986.207 3 3 0 0 0-1.624 1.624 3.069 3.069 0 0 0-.207.986 6.566 6.566 0 0 0-.009.162Zm2.605-.924c.042-.017.129-.044.357-.06C7.21 14.002 7.52 14 8 14s.79 0 1.026.017c.228.015.315.042.357.06a1 1 0 0 1 .54.54c.018.042.045.129.06.357C10 15.21 10 15.52 10 16s0 .79-.017 1.026c-.015.228-.042.315-.06.357a1 1 0 0 1-.54.54c-.042.018-.129.045-.357.06C8.79 18 8.48 18 8 18s-.79 0-1.026-.017c-.228-.015-.315-.042-.357-.06a1 1 0 0 1-.54-.54c-.018-.042-.045-.129-.06-.357A16.908 16.908 0 0 1 6 16c0-.48 0-.79.017-1.026.015-.228.042-.315.06-.357a1 1 0 0 1 .54-.54Z"
      fill="currentColor"
    />
  </svg>
);

export const Passport = (props: SVGProps<SVGSVGElement>) => (
  <svg width="17" height="17" viewBox="0 0 17 17" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.166 6.443c0-.737.597-1.334 1.333-1.334h2.619c.736 0 1.333.597 1.333 1.334v4.065c0 .736-.597 1.333-1.333 1.333H4.499a1.333 1.333 0 0 1-1.333-1.333V6.443Zm3.952 0H4.499v4.065h2.619V6.443Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.533 6.531h3.934V5.198H9.533V6.53ZM13.467 8.523H9.533V7.19h3.934v1.333ZM9.533 10.658h2.574V9.324H9.533v1.334Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.166 4.547a2 2 0 0 1 2-2h10.667a2 2 0 0 1 2 2v7.858a2 2 0 0 1-2 2H3.166a2 2 0 0 1-2-2V4.547Zm2-.667a.667.667 0 0 0-.667.667v7.858c0 .368.299.666.667.666h10.667a.667.667 0 0 0 .666-.666V4.547a.667.667 0 0 0-.666-.667H3.166Z"
      clipRule="evenodd"
    />
  </svg>
);

export const Block = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C9.34784 2 6.8043 3.05357 4.92893 4.92893C3.05357 6.8043 2 9.34784 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C6.8043 20.9464 9.34784 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM6.34315 6.34315C7.84344 4.84285 9.87827 4 12 4C13.7859 4 15.5102 4.59715 16.906 5.68088L5.68088 16.906C4.59715 15.5102 4 13.7859 4 12C4 9.87827 4.84285 7.84344 6.34315 6.34315ZM7.09523 18.3201C8.49082 19.4032 10.2146 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 10.2146 19.4032 8.49082 18.3201 7.09523L7.09523 18.3201Z"
    />
  </svg>
);

export const RecurringPaymentsOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.502 11.598V6.5h3.142c.575 0 1.098.068 1.568.204.481.125.89.324 1.224.596.335.272.596.617.784 1.035.188.419.283.915.283 1.49 0 .586-.1 1.083-.299 1.49a2.636 2.636 0 0 1-.8.989c-.345.261-.758.45-1.239.565a6.812 6.812 0 0 1-1.584.172h-.836v.941h3.06v1.444h-3.06V17.5H9.502v-2.075H8v-1.443h1.502v-.94H8v-1.444h1.502Zm2.243-3.357v3.357h.867c1.109 0 1.663-.586 1.663-1.757 0-.585-.13-.999-.392-1.24-.251-.24-.664-.36-1.24-.36h-.898Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.883 3.606c.54-.337 1.19-.486 2.117-.553V2h2v1h6V2h2v1.053c.927.067 1.577.216 2.117.553a4 4 0 0 1 1.277 1.277C21 5.855 21 7.183 21 9.84v4.32c0 2.657 0 3.985-.606 4.957a4 4 0 0 1-1.277 1.277c-.972.606-2.3.606-4.957.606H9.84c-2.657 0-3.985 0-4.957-.606a4 4 0 0 1-1.277-1.277C3 18.145 3 16.817 3 14.16V9.84c0-2.657 0-3.985.606-4.957a4 4 0 0 1 1.277-1.277ZM9.84 5 9 5.001V6H7v-.94a8.614 8.614 0 0 0-.078.007c-.637.06-.865.164-.98.236a2 2 0 0 0-.639.639c-.072.115-.175.343-.236.98-.05.52-.063 1.17-.066 2.078L5 14.16c0 1.368.002 2.251.067 2.918.06.637.164.865.236.98a2 2 0 0 0 .639.639c.115.072.343.175.98.236.667.065 1.55.067 2.918.067h4.32c1.368 0 2.251-.002 2.918-.067.637-.06.865-.164.98-.236a2 2 0 0 0 .639-.639c.072-.115.175-.343.236-.98.065-.667.067-1.55.067-2.918L18.999 9c-.003-.908-.015-1.559-.066-2.078-.06-.637-.164-.865-.236-.98a2 2 0 0 0-.639-.639c-.115-.072-.343-.175-.98-.236A8.475 8.475 0 0 0 17 5.059V6h-2v-.999L14.16 5H9.84Z"
      fill="currentColor"
    />
  </svg>
);

export const CalendarCheckOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="m11 16 6.5-6.5L16 8l-4.99 5L8 10l-1.5 1.5L11 16Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.883 3.606c.54-.337 1.19-.486 2.117-.553V2h2v1h6V2h2v1.053c.927.067 1.577.216 2.117.553a4 4 0 0 1 1.277 1.277C21 5.855 21 7.183 21 9.84v4.32c0 2.657 0 3.985-.606 4.957a4 4 0 0 1-1.277 1.277c-.972.606-2.3.606-4.957.606H9.84c-2.657 0-3.985 0-4.957-.606a4 4 0 0 1-1.277-1.277C3 18.145 3 16.817 3 14.16V9.84c0-2.657 0-3.985.606-4.957a4 4 0 0 1 1.277-1.277ZM9.84 5 9 5.001V6H7v-.94a8.614 8.614 0 0 0-.078.007c-.637.06-.865.164-.98.236a2 2 0 0 0-.639.639c-.072.115-.175.343-.236.98-.05.52-.063 1.17-.066 2.078L5 14.16c0 1.368.002 2.251.067 2.918.06.637.164.865.236.98a2 2 0 0 0 .639.639c.115.072.343.175.98.236.667.065 1.55.067 2.918.067h4.32c1.368 0 2.251-.002 2.918-.067.637-.06.865-.164.98-.236a2 2 0 0 0 .639-.639c.072-.115.175-.343.236-.98.065-.667.067-1.55.067-2.918L18.999 9c-.003-.908-.015-1.559-.066-2.078-.06-.637-.164-.865-.236-.98a2 2 0 0 0-.639-.639c-.115-.072-.343-.175-.98-.236A8.475 8.475 0 0 0 17 5.059V6h-2v-.999L14.16 5H9.84Z"
      fill="currentColor"
    />
  </svg>
);

export const CalendarPauseOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M14 16V8h2v8h-2ZM8 16V8h2v8H8Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 3.053c-.927.067-1.577.216-2.117.553a4 4 0 0 0-1.277 1.277C3 5.855 3 7.183 3 9.84v4.32c0 2.657 0 3.985.606 4.957a4 4 0 0 0 1.277 1.277C5.855 21 7.183 21 9.84 21h4.32c2.657 0 3.985 0 4.957-.606a4 4 0 0 0 1.277-1.277c.606-.972.606-2.3.606-4.957V9.84c0-2.657 0-3.985-.606-4.957a4 4 0 0 0-1.277-1.277c-.54-.337-1.19-.486-2.117-.553V2h-2v1H9V2H7v1.053Zm2 1.948L9.84 5h4.32l.84.001V6h2v-.94l.078.007c.637.06.865.164.98.236a2 2 0 0 1 .639.639c.072.115.175.343.236.98.05.52.063 1.17.066 2.078L19 14.16c0 1.368-.002 2.251-.067 2.918-.06.637-.164.865-.236.98a2 2 0 0 1-.639.639c-.115.072-.343.175-.98.236-.667.065-1.55.067-2.918.067H9.84c-1.368 0-2.251-.002-2.918-.067-.637-.06-.865-.164-.98-.236a2 2 0 0 1-.639-.639c-.072-.115-.175-.343-.236-.98C5.002 16.411 5 15.528 5 14.16L5.001 9c.003-.908.015-1.559.066-2.078.06-.637.164-.865.236-.98a2 2 0 0 1 .639-.639c.115-.072.343-.175.98-.236L7 5.059V6h2v-.999Z"
      fill="currentColor"
    />
  </svg>
);

export const CalendarCancelOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M16 9.406 13.406 12l2.59 2.59-1.406 1.407-2.59-2.59L9.406 16 8 14.594 10.594 12l-2.59-2.59L9.41 8.003l2.59 2.59L14.594 8 16 9.406Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.883 3.606c.54-.337 1.19-.486 2.117-.553V2h2v1h6V2h2v1.053c.927.067 1.577.216 2.117.553a4 4 0 0 1 1.277 1.277C21 5.855 21 7.183 21 9.84v4.32c0 2.657 0 3.985-.606 4.957a4 4 0 0 1-1.277 1.277c-.972.606-2.3.606-4.957.606H9.84c-2.657 0-3.985 0-4.957-.606a4 4 0 0 1-1.277-1.277C3 18.145 3 16.817 3 14.16V9.84c0-2.657 0-3.985.606-4.957a4 4 0 0 1 1.277-1.277ZM9.84 5 9 5.001V6H7v-.94a8.614 8.614 0 0 0-.078.007c-.637.06-.865.164-.98.236a2 2 0 0 0-.639.639c-.072.115-.175.343-.236.98-.05.52-.063 1.17-.066 2.078L5 14.16c0 1.368.002 2.251.067 2.918.06.637.164.865.236.98a2 2 0 0 0 .639.639c.115.072.343.175.98.236.667.065 1.55.067 2.918.067h4.32c1.368 0 2.251-.002 2.918-.067.637-.06.865-.164.98-.236a2 2 0 0 0 .639-.639c.072-.115.175-.343.236-.98.065-.667.067-1.55.067-2.918L18.999 9c-.003-.908-.015-1.559-.066-2.078-.06-.637-.164-.865-.236-.98a2 2 0 0 0-.639-.639c-.115-.072-.343-.175-.98-.236A8.475 8.475 0 0 0 17 5.059V6h-2v-.999L14.16 5H9.84Z"
      fill="currentColor"
    />
  </svg>
);

export const ChevronInlineEndGlyph = (props: SVGProps<SVGSVGElement>) => {
  const { textInfo } = useLocale();

  return textInfo.direction === "rtl" ? (
    <svg width="6" height="6" fill="none" viewBox="0 0 6 6" {...props}>
      <path
        fill="currentColor"
        d="m4.13 0 .52.53L2.17 3l2.48 2.47-.53.53-3-3 3-3Z"
      />
    </svg>
  ) : (
    <svg width="6" height="6" fill="none" viewBox="0 0 6 6" {...props}>
      <path
        fill="currentColor"
        d="m1.88 6-.53-.53L3.83 3 1.35.52 1.87 0l3 3-3 3Z"
      />
    </svg>
  );
};

export const GosuslugiOutline = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" {...props}>
      <g fill="currentColor">
        <path d="m13.2121 1.07275h-2.6734c-.3333.00001-.5733.31989-.4801.63986l.4738 1.62638c.0622.21341.2578.36015.4801.36015h1.7258c.2223 0 .4178-.14674.48-.36015l.4738-1.62638c.0932-.31997-.1467-.63985-.48-.63986z" />
        <path d="m6.80755 6.84374c-.34413-.25158-.74318-.73118-.74317-1.42734.00004-1.60738 2.04624-1.84385 3.62219-.98087 1.11903.58653 1.92193 1.76705 1.92193 3.08263 0 1.47749-.818 2.63734-2.0201 3.10594-1.18923.4635-2.59867.1947-3.71695-.80563-.75233-.67296-1.28965-1.13192-1.7591-1.52913l-.21931-.18533c-.20345-.17182-.40014-.33793-.60154-.51062-.43343 1.30552-.29419 2.84291.29197 4.16801.62386 1.4103 1.64134 2.354 2.71839 2.5956.7455-.7753 1.648-1.1214 2.55915-1.0125.98827.118 1.79569.7521 2.24109 1.5327.4522.7924.5881 1.8398.0792 2.8045-.3348.6345-1.3493 1.2435-2.18838 1.2435-.03404.0972-.05598.1718-.07899.25-.01396.0475-.02831.0963-.04601.1523.46938.4637 1.69968.9007 3.12028.9007 1.4246 0 2.5594-.5296 2.993-.9085l-.0125-.0834c-.0206-.1377-.0366-.2441-.0617-.3424-1.1758-.0273-1.7761-.62-2.0885-1.2122-.5089-.9647-.373-2.0121.0792-2.8045.4454-.7806 1.2528-1.4147 2.2411-1.5327.9111-.1089 1.8136.2372 2.5591 1.0125 1.0771-.2416 2.0946-1.1853 2.7184-2.5956.5862-1.3251.7254-2.86248.292-4.16801-.2013.17261-.3982.33889-.6016.51063l-.2193.18532c-.4694.39721-1.0067.85617-1.7591 1.52913-1.1182 1.00033-2.5277 1.26913-3.7169.80563-1.2021-.4686-2.0202-1.62845-2.0202-3.10594 0-1.31752.8054-2.49957 1.927-3.08521 1.5753-.85993 3.6174-.62232 3.6174.98345 0 .69616-.399 1.17576-.7432 1.42734-.1005.07349-.2396.01603-.32-.07908-.4055-.47996-1.607-.75786-2.21-.05021-.1683.23665-.2712.51595-.2712.80371 0 .69204.348 1.08712.7465 1.24245.4114.16034 1.0371.12189 1.6572-.4328.7705-.68915 1.3226-1.16078 1.8007-1.56528l.2243-.18956c.3821-.32269.7206-.60866 1.1124-.95589.6439-.57076 1.787-.52871 2.2703.39327 1.0898 2.07889.9181 4.58125.0428 6.56015-.8665 1.9587-2.561 3.6833-4.7873 3.8372-.4443.0307-.8154-.189-1.03-.465-.4528-.5824-.8362-.6382-1.052-.6124-.2688.0321-.562.2239-.7413.5381-.1725.3023-.1853.6187-.0474.88.1392.2638.5462.6836 1.647.9178.487.1036 1.1163.6346.9131 1.4367-.4188 1.6532-2.3245 3.1253-5.1593 3.1253-2.842 0-4.71852-1.4778-5.13591-3.1253-.20319-.8021.42612-1.3331.91307-1.4367 1.1008-.2342 1.50787-.654 1.64702-.9178.13789-.2614.12511-.5777-.04739-.88-.17928-.3142-.47255-.506-.74126-.5381-.21583-.0258-.59927.03-1.05208.6124-.21459.276-.58567.4957-1.02992.465-2.22639-.1539-3.92085-1.8785-4.7873-3.8372-.875337-1.9789-1.047046-4.48126.04273-6.56015.48331-.92198 1.62647-.96403 2.27036-.39327.39171.34722.73028.63318 1.11232.95585l.22434.1896c.47808.4045 1.03023.87613 1.80067 1.56528.62011.55469 1.24587.59314 1.65724.4328.39853-.15533.74646-.55041.74646-1.24245 0-.28837-.10333-.56824-.27219-.80521-.60348-.70575-1.80358-.42791-2.20877.05171-.08036.09511-.21952.15257-.32004.07908z" />
      </g>
    </svg>
  );
};

export const LoyaltyBasicFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="47" height="32" viewBox="0 0 47 32" fill="none" {...props}>
    <g filter="url(#filter0_iin_14601_45288)">
      <rect
        width="47"
        height="32"
        rx="6"
        fill="url(#paint0_linear_14601_45288)"
      />
      <rect
        x="0.397959"
        y="0.397959"
        width="46.2041"
        height="31.2041"
        rx="5.60204"
        stroke="url(#paint1_linear_14601_45288)"
        strokeWidth="0.795918"
      />
      <g filter="url(#filter1_di_14601_45288)">
        <path
          d="M27.2806 5.06841C26.6891 4.77332 26.0669 4.50875 25.4957 4.28489C24.5354 3.9078 23.4676 3.9078 22.5073 4.28489C21.0264 4.8538 19.591 5.53413 18.2134 6.32001C16.9954 7.045 15.8298 7.85425 14.7252 8.7418C14.2875 9.08845 13.9258 9.52112 13.6627 10.013C13.3995 10.5048 13.2404 11.0454 13.1953 11.6011C13.1953 11.7945 13.1953 11.998 13.1953 12.1811L16.6733 15.6917L27.2806 5.06841Z"
          fill="#7999B6"
        />
        <path
          d="M25.4637 24.4732L34.8675 12.3236C34.9491 13.3411 34.8165 11.6723 34.8165 11.6011C34.7702 11.0446 34.6095 10.5035 34.3445 10.0116C34.0796 9.51971 33.716 9.08745 33.2764 8.74175C32.9194 8.45683 32.5217 8.16174 32.1239 7.87682C31.4099 7.36804 30.6348 6.85926 29.7882 6.36066C28.9417 5.86205 28.1053 5.44486 27.2792 5.06836L16.6719 15.6917L25.4637 24.4732Z"
          fill="#5C7B9E"
        />
        <path
          d="M27.7075 26.7018L20.6495 26.8646C20.058 26.5695 18.834 25.9589 18.2119 25.5926C17.4071 25.1286 16.6275 24.6225 15.8762 24.0765C15.4784 23.7915 15.0807 23.5066 14.7237 23.2217C14.2829 22.8749 13.9186 22.441 13.6536 21.9472C13.3886 21.4535 13.2286 20.9105 13.1836 20.3522C13.1836 19.9961 13.1836 19.6094 13.1122 19.2431C13.051 18.2459 13 17.1265 13 15.9869C13 14.6335 13.0612 13.3819 13.153 12.1405L16.6616 15.6511L27.7075 26.7018Z"
          fill="#4F6A8D"
        />
        <path
          d="M34.9991 15.9869C34.9991 17.5336 34.9277 19.0396 34.8155 20.3522C34.7705 20.9105 34.6105 21.4535 34.3455 21.9472C34.0805 22.441 33.7162 22.8749 33.2754 23.2217C32.1692 24.0918 31.0037 24.884 29.7873 25.5926C29.0733 26.0098 28.3797 26.3762 27.6964 26.7018C27.013 27.0274 26.1869 27.4039 25.4933 27.7193C24.533 28.0964 23.4652 28.0964 22.5049 27.7193C21.6663 27.3938 20.8457 27.0235 20.0469 26.6102L34.8257 11.8251C34.9379 13.1581 34.9991 14.5013 34.9991 15.9869Z"
          fill="#45586E"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_iin_14601_45288"
        x="-0.795918"
        y="-1.59184"
        width="49.3878"
        height="34.3878"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.795918" dy="0.795918" />
        <feGaussianBlur stdDeviation="0.676531" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.26572 0 0 0 0 0.333689 0 0 0 0 0.416222 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_14601_45288"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.59184" dy="-1.59184" />
        <feGaussianBlur stdDeviation="2.82551" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.160223 0 0 0 0 0.213313 0 0 0 0 0.271991 0 0 0 0.76 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_14601_45288"
          result="effect2_innerShadow_14601_45288"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="12.564103126525879 12.564103126525879"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3601"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect2_innerShadow_14601_45288"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood flood-color="rgba(0, 0, 0, 0.05)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect3_noise_14601_45288">
          <feMergeNode in="effect2_innerShadow_14601_45288" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_di_14601_45288"
        x="10.1144"
        y="3.0402"
        width="25.8465"
        height="27.8476"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.961872" dy="0.961872" />
        <feGaussianBlur stdDeviation="0.961872" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.266667 0 0 0 0 0.333333 0 0 0 0 0.415686 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14601_45288"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_14601_45288"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.92374" dy="1.92374" />
        <feGaussianBlur stdDeviation="1.92374" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.618017 0 0 0 0 0.729862 0 0 0 0 0.834491 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_14601_45288"
        />
      </filter>
      <linearGradient
        id="paint0_linear_14601_45288"
        x1="-0.900551"
        y1="33.2525"
        x2="54.3314"
        y2="8.82949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#44576D" />
        <stop offset="1" stopColor="#8FACC7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_14601_45288"
        x1="43.3846"
        y1="4"
        x2="-3.42115"
        y2="23.9892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#89A6C2" />
        <stop offset="1" stopColor="#212B37" />
      </linearGradient>
    </defs>
  </svg>
);

export const LoyaltyBronzeFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="47" height="32" viewBox="0 0 47 32" fill="none" {...props}>
    <g filter="url(#filter0_iin_14601_45325)">
      <rect
        width="47"
        height="32"
        rx="6"
        fill="url(#paint0_linear_14601_45325)"
      />
      <rect
        x="0.397959"
        y="0.397959"
        width="46.2041"
        height="31.2041"
        rx="5.60204"
        stroke="url(#paint1_linear_14601_45325)"
        strokeWidth="0.795918"
      />
      <g filter="url(#filter1_di_14601_45325)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.4422 5.29704C25.1693 4.90099 22.8298 4.90099 20.557 5.29704C16.6849 5.97034 14.8143 6.95541 13.9359 7.84197C13.4854 8.29895 13.1885 8.88796 13.1066 9.51759C12.4718 14.2703 14.8789 18.7589 14.8789 18.7589C15.3723 19.7795 15.9293 20.6783 16.5139 21.4816L33.1121 7.11383C32.0258 6.44866 30.2699 5.78856 27.4422 5.29704Z"
          fill="#C9918C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.067 7.84191C33.8315 7.60427 33.5141 7.3575 33.1148 7.11377L16.5156 21.4815C18.6544 24.4164 21.1935 25.9773 22.6975 26.7024C23.5216 27.0994 24.484 27.0994 25.3072 26.7013C27.2207 25.7782 30.8102 23.5105 33.1148 18.7589C33.1148 18.7589 35.531 14.2702 34.8963 9.51753C34.8144 8.8879 34.5175 8.2989 34.067 7.84191Z"
          fill="#A06C6C"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_iin_14601_45325"
        x="-0.795918"
        y="-1.59184"
        width="49.3878"
        height="34.3878"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.795918" dy="0.795918" />
        <feGaussianBlur stdDeviation="0.676531" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.584314 0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_14601_45325"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.59184" dy="-1.59184" />
        <feGaussianBlur stdDeviation="2.82551" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.47968 0 0 0 0 0.332987 0 0 0 0 0.332987 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_14601_45325"
          result="effect2_innerShadow_14601_45325"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="12.564103126525879 12.564103126525879"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3601"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect2_innerShadow_14601_45325"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(0, 0, 0, 0.05)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect3_noise_14601_45325">
          <feMergeNode in="effect2_innerShadow_14601_45325" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_di_14601_45325"
        x="9.11439"
        y="3.03813"
        width="27.8475"
        height="27.8475"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.961872" dy="0.961872" />
        <feGaussianBlur stdDeviation="0.961872" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.470588 0 0 0 0 0.301961 0 0 0 0 0.301961 0 0 0 0.8 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14601_45325"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_14601_45325"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.92374" dy="1.92374" />
        <feGaussianBlur stdDeviation="1.92374" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.92841 0 0 0 0 0.716948 0 0 0 0 0.711233 0 0 0 0.86 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_14601_45325"
        />
      </filter>
      <linearGradient
        id="paint0_linear_14601_45325"
        x1="-0.900551"
        y1="33.2525"
        x2="54.3314"
        y2="8.82949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9C6464" />
        <stop offset="1" stopColor="#DAAAA8" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_14601_45325"
        x1="43.3846"
        y1="4"
        x2="-3.42115"
        y2="23.9892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DCABA9" />
        <stop offset="1" stopColor="#573535" />
      </linearGradient>
    </defs>
  </svg>
);

export const LoyaltySilverFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="47" height="32" viewBox="0 0 47 32" fill="none" {...props}>
    <g filter="url(#filter0_iin_14601_45330)">
      <rect
        width="47"
        height="32"
        rx="6"
        fill="url(#paint0_linear_14601_45330)"
      />
      <rect
        x="0.397959"
        y="0.397959"
        width="46.2041"
        height="31.2041"
        rx="5.60204"
        stroke="url(#paint1_linear_14601_45330)"
        strokeWidth="0.795918"
      />
      <g filter="url(#filter1_di_14601_45330)">
        <path
          d="M25.2097 4.426C24.8664 4.15104 24.4398 4.00122 24 4.00122C23.5602 4.00122 23.1336 4.15104 22.7903 4.426C20.8788 5.9499 19.0563 7.5823 17.3319 9.31515C15.5862 11.0627 13.9415 12.9084 12.4058 14.8433C12.1433 15.1661 12 15.5695 12 15.9857C12 16.4018 12.1433 16.8053 12.4058 17.1281C13.1704 18.0963 13.9736 19.0644 14.8059 20.0325L27.997 6.78828C27.0873 5.93631 26.1582 5.18115 25.2097 4.426Z"
          fill="#BCBAB8"
        />
        <path
          d="M30.754 9.40233C30.7242 9.36767 30.6918 9.33531 30.6572 9.30552C29.7958 8.44386 28.9151 7.60157 27.9957 6.78833L14.8047 19.9842C15.6273 20.9039 16.4693 21.7946 17.3403 22.666C17.3685 22.6893 17.3944 22.7152 17.4177 22.7434C18.2694 23.5954 19.1501 24.428 20.0598 25.2316L33.2896 12.0454C32.4379 11.1353 31.6056 10.2543 30.754 9.40233Z"
          fill="#B1AFAD"
        />
        <path
          d="M35.5956 14.8434C34.8407 13.8752 34.0568 12.9555 33.2439 12.0454L20.0625 25.2316C20.9722 26.0448 21.911 26.8387 22.8594 27.6036C23.1844 27.8611 23.5868 28.0013 24.0014 28.0013C24.416 28.0013 24.8185 27.8611 25.1434 27.6036C27.0754 26.0579 28.9203 24.4063 30.6695 22.6563C32.4152 20.9087 34.0599 19.063 35.5956 17.1282C35.8581 16.8054 36.0014 16.4019 36.0014 15.9858C36.0014 15.5696 35.8581 15.1662 35.5956 14.8434Z"
          fill="#959593"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_iin_14601_45330"
        x="-0.795918"
        y="-1.59184"
        width="49.3878"
        height="34.3878"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.795918" dy="0.795918" />
        <feGaussianBlur stdDeviation="0.676531" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.574031 0 0 0 0 0.574031 0 0 0 0 0.568026 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_14601_45330"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.59184" dy="-1.59184" />
        <feGaussianBlur stdDeviation="2.82551" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.401762 0 0 0 0 0.401762 0 0 0 0 0.394269 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_14601_45330"
          result="effect2_innerShadow_14601_45330"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="12.564103126525879 12.564103126525879"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3601"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect2_innerShadow_14601_45330"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(0, 0, 0, 0.05)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect3_noise_14601_45330">
          <feMergeNode in="effect2_innerShadow_14601_45330" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_di_14601_45330"
        x="9.11439"
        y="3.03813"
        width="27.849"
        height="27.8488"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.961872" dy="0.961872" />
        <feGaussianBlur stdDeviation="0.961872" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.432907 0 0 0 0 0.44065 0 0 0 0 0.450214 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14601_45330"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_14601_45330"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.92374" dy="1.92374" />
        <feGaussianBlur stdDeviation="1.92374" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.853178 0 0 0 0 0.843831 0 0 0 0 0.825138 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_14601_45330"
        />
      </filter>
      <linearGradient
        id="paint0_linear_14601_45330"
        x1="-0.900551"
        y1="33.2525"
        x2="54.3314"
        y2="8.82949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#858582" />
        <stop offset="1" stopColor="#BBB9B7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_14601_45330"
        x1="43.3846"
        y1="4"
        x2="-3.42115"
        y2="23.9892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D2D0CE" />
        <stop offset="1" stopColor="#5A5A57" />
      </linearGradient>
    </defs>
  </svg>
);

export const LoyaltyGoldFill = (props: SVGProps<SVGSVGElement>) => (
  <svg width="47" height="32" viewBox="0 0 47 32" fill="none" {...props}>
    <g filter="url(#filter0_iin_14604_45235)">
      <rect
        width="47"
        height="32"
        rx="6"
        fill="url(#paint0_linear_14604_45235)"
      />
      <rect
        x="0.397959"
        y="0.397959"
        width="46.2041"
        height="31.2041"
        rx="5.60204"
        stroke="url(#paint1_linear_14604_45235)"
        strokeWidth="0.795918"
      />
      <g filter="url(#filter1_di_14604_45235)">
        <path
          d="M35.138 20.5886C33.672 21.8239 32.0409 23.0898 30.2962 24.3556L29.078 25.1928L28.9645 25.2744L28.2935 25.7134L27.4779 26.2442C26.683 26.7547 25.8984 27.2651 25.279 27.6326C25.0869 27.7534 24.8783 27.8462 24.6596 27.9083C24.3334 27.9995 23.9917 28.023 23.6559 27.9773C23.3201 27.9317 22.9975 27.8178 22.7084 27.6428C22.0064 27.2141 21.2941 26.7445 20.5611 26.2851L19.7662 25.7542L19.1675 25.3561L18.7648 25.0805L17.7325 24.3658C17.3712 24.1106 17.0511 23.8554 16.7001 23.6002C15.3374 22.5793 14.047 21.5585 12.8804 20.6091C12.5321 20.315 12.2727 19.9317 12.1306 19.5012C11.9885 19.0707 11.9693 18.6098 12.0752 18.1692C12.4572 16.6175 13.1075 14.4328 13.6753 12.6055C13.6753 12.5442 13.6753 12.4932 13.6753 12.4421L13.8612 11.8704C14.4806 10.0329 15.131 8.31782 15.7917 6.7661C15.9648 6.35363 16.2487 5.99581 16.6126 5.73132C16.9765 5.46683 17.4066 5.30573 17.8564 5.26543C19.8385 5.08167 21.8929 5 24.0711 5C26.2494 5 28.2005 5.08167 30.0898 5.22459C30.5402 5.26267 30.9713 5.42292 31.3356 5.68769C31.6999 5.95246 31.9832 6.31149 32.1545 6.72527C32.299 7.08257 32.4435 7.4705 32.588 7.83801C33.1042 9.1243 33.6204 10.4514 34.0746 11.9215C34.1469 12.1052 34.2088 12.289 34.2708 12.483L34.3327 12.6565C34.9625 14.5962 35.4786 16.4541 35.9122 18.21C36.012 18.6387 35.9927 19.0861 35.8564 19.5048C35.7201 19.9235 35.4719 20.298 35.138 20.5886Z"
          fill="#F4C674"
        />
        <path
          d="M13.9004 11.8705C13.2604 13.8203 12.4964 16.4133 12.0731 18.1692C11.9621 18.6072 11.9777 19.0672 12.1183 19.4968C12.2588 19.9264 12.5186 20.3083 12.8681 20.5989C14.0346 21.6198 15.3251 22.6406 16.6774 23.59C17.0284 23.8453 17.3485 24.1005 17.7098 24.3557C18.6596 25.0499 19.599 25.6828 20.5281 26.2851L25.0395 21.8137L13.9004 11.8705Z"
          fill="#EBB361"
        />
        <path
          d="M35.1435 20.5783C33.6775 21.8136 32.0464 23.0794 30.3018 24.3453C29.5481 24.9068 28.5158 25.5908 27.4834 26.2441C26.6885 26.7546 25.9039 27.265 25.2845 27.6325C24.8991 27.8706 24.4537 27.9968 23.9992 27.9968C23.5448 27.9968 23.0994 27.8706 22.714 27.6325C22.012 27.2037 21.279 26.7341 20.546 26.2543L18.7188 25.0599L34.1111 11.8601L34.3486 12.6053C34.9783 14.545 35.4945 16.403 35.9281 18.1589C36.0346 18.5945 36.0178 19.0507 35.8794 19.4775C35.741 19.9043 35.4864 20.2852 35.1435 20.5783Z"
          fill="#C88A37"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_iin_14604_45235"
        x="-0.795918"
        y="-1.59184"
        width="49.3878"
        height="34.3878"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.795918" dy="0.795918" />
        <feGaussianBlur stdDeviation="0.676531" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.764706 0 0 0 0 0.529412 0 0 0 0 0.211765 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_14604_45235"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="1.59184" dy="-1.59184" />
        <feGaussianBlur stdDeviation="2.82551" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.630446 0 0 0 0 0.396677 0 0 0 0 0.0824288 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_14604_45235"
          result="effect2_innerShadow_14604_45235"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="12.564103126525879 12.564103126525879"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3601"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect2_innerShadow_14604_45235"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood flood-color="rgba(0, 0, 0, 0.05)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect3_noise_14604_45235">
          <feMergeNode in="effect2_innerShadow_14604_45235" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_di_14604_45235"
        x="9.11439"
        y="3.03813"
        width="27.8475"
        height="27.8475"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.961872" dy="0.961872" />
        <feGaussianBlur stdDeviation="0.961872" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.664494 0 0 0 0 0.437807 0 0 0 0 0.134277 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_14604_45235"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_14604_45235"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.92374" dy="1.92374" />
        <feGaussianBlur stdDeviation="1.92374" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.855332 0 0 0 0 0.598145 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect2_innerShadow_14604_45235"
        />
      </filter>
      <linearGradient
        id="paint0_linear_14604_45235"
        x1="-0.900551"
        y1="33.2525"
        x2="54.3314"
        y2="8.82949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C48736" />
        <stop offset="1" stopColor="#F8CB7A" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_14604_45235"
        x1="43.3846"
        y1="4"
        x2="-3.42115"
        y2="23.9892"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9D390" />
        <stop offset="1" stopColor="#96631E" />
      </linearGradient>
    </defs>
  </svg>
);

export const RouteFrom1To10 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      d="M4.466 22H2.874v-4.071L1.65 19.12v-1.464l1.424-1.383h1.392V22ZM7.363 8.35a4.651 4.651 0 0 1 4.65 4.65v4.5a2.85 2.85 0 1 0 5.7 0V10h1.3v7.5a4.151 4.151 0 0 1-8.3 0V13a3.35 3.35 0 0 0-6.7 0v1h-1.3v-1a4.65 4.65 0 0 1 4.65-4.65Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.776 1.93c.475 0 .902.107 1.28.32.38.208.678.528.896.96.224.427.336.97.336 1.632 0 .661-.112 1.213-.336 1.656-.218.437-.517.765-.895.983a2.514 2.514 0 0 1-1.28.329c-.48 0-.913-.107-1.297-.32-.378-.214-.68-.537-.904-.969-.224-.437-.336-.99-.336-1.656 0-.666.112-1.215.336-1.647.224-.438.526-.76.904-.968.384-.213.816-.32 1.296-.32Zm0 1.168a.743.743 0 0 0-.48.168c-.139.112-.248.299-.328.56-.08.256-.12.606-.12 1.048 0 .656.08 1.115.24 1.376.165.256.393.384.68.384.288 0 .512-.128.672-.384.16-.261.24-.72.24-1.376 0-.442-.04-.792-.12-1.048-.074-.261-.181-.448-.32-.56a.7.7 0 0 0-.464-.168Z"
      fill="currentColor"
    />
    <path
      d="M16.466 7.73h-1.592V3.656L13.65 4.85V3.386l1.424-1.384h1.392v5.727Z"
      fill="currentColor"
    />
  </svg>
);

export const RouteFrom11To50 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      d="M4.104 22H2.51v-4.071L1.287 19.12v-1.464l1.424-1.383h1.393V22ZM7.639 22H6.047v-4.071L4.822 19.12v-1.464l1.424-1.383H7.64V22Z"
      fill="currentColor"
    />
    <path
      d="M7.363 8.35a4.65 4.65 0 0 1 4.65 4.65v4.5a2.85 2.85 0 1 0 5.7 0V10h1.3v7.5a4.15 4.15 0 0 1-8.3 0V13a3.35 3.35 0 1 0-6.7 0v1h-1.3v-1a4.65 4.65 0 0 1 4.65-4.65ZM17.008 3.218h-2.36v.984c.095-.064.218-.117.368-.16.149-.048.328-.072.536-.072.533 0 .954.154 1.263.464.31.309.464.747.464 1.312 0 .432-.098.802-.296 1.111a1.949 1.949 0 0 1-.815.705c-.347.165-.75.248-1.208.248-.352 0-.665-.032-.937-.096a2.348 2.348 0 0 1-.76-.328V6.202c.273.165.523.285.753.36.234.069.474.104.72.104.303 0 .536-.078.696-.232.16-.155.24-.366.24-.632a.802.802 0 0 0-.176-.536c-.112-.139-.293-.208-.544-.208a.867.867 0 0 0-.352.064.605.605 0 0 0-.224.16h-1.009v-3.28h3.64v1.216Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.188 1.93c.474 0 .9.107 1.279.32.379.208.678.528.896.96.224.427.336.97.336 1.632 0 .661-.112 1.213-.336 1.656-.218.437-.518.765-.896.983a2.512 2.512 0 0 1-1.28.329c-.48 0-.912-.107-1.296-.32-.379-.214-.68-.537-.904-.969-.224-.437-.336-.99-.336-1.656 0-.666.112-1.215.336-1.647.224-.437.525-.76.904-.968.384-.213.817-.32 1.297-.32Zm0 1.168a.743.743 0 0 0-.481.168c-.139.112-.248.299-.328.56-.08.256-.12.606-.12 1.048 0 .656.08 1.115.24 1.376.165.256.392.384.68.384a.753.753 0 0 0 .673-.384c.16-.261.239-.72.239-1.376 0-.442-.04-.792-.12-1.048-.075-.261-.181-.448-.32-.56a.7.7 0 0 0-.463-.168Z"
      fill="currentColor"
    />
  </svg>
);

export const RouteFrom51To100 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      d="M5.008 17.488h-2.36v.985c.095-.064.218-.118.368-.16.149-.048.328-.073.536-.073.533 0 .954.155 1.263.464.31.31.464.747.464 1.313 0 .431-.098.803-.296 1.112-.197.304-.469.538-.815.703-.347.165-.75.248-1.208.248-.352 0-.665-.032-.937-.096a2.347 2.347 0 0 1-.76-.328v-1.183c.273.165.523.284.753.359.234.07.474.104.72.104.303 0 .536-.077.696-.232.16-.155.24-.365.24-.632a.802.802 0 0 0-.176-.536c-.112-.138-.293-.208-.544-.208a.867.867 0 0 0-.352.065.604.604 0 0 0-.224.16H1.367v-3.28h3.64v1.215ZM8.35 22H6.758v-4.071L5.534 19.12v-1.464l1.424-1.383H8.35V22Z"
      fill="currentColor"
    />
    <path
      d="M7.363 8.35a4.65 4.65 0 0 1 4.65 4.65v4.5a2.85 2.85 0 1 0 5.7 0V10h1.3v7.5a4.15 4.15 0 0 1-8.3 0V13a3.35 3.35 0 1 0-6.7 0v1h-1.3v-1a4.65 4.65 0 0 1 4.65-4.65Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.413 1.93c.475 0 .902.107 1.28.32.379.208.677.528.896.96.224.427.336.97.336 1.632 0 .661-.112 1.213-.336 1.656-.219.437-.517.765-.896.983a2.514 2.514 0 0 1-1.28.329c-.48 0-.912-.107-1.296-.32-.378-.214-.68-.537-.904-.969-.224-.437-.336-.99-.336-1.656 0-.666.112-1.215.336-1.647.224-.438.526-.76.904-.968.384-.213.816-.32 1.296-.32Zm0 1.168a.742.742 0 0 0-.48.168c-.138.112-.248.299-.328.56-.08.256-.12.606-.12 1.048 0 .656.08 1.115.24 1.376.166.256.392.384.68.384.288 0 .512-.128.672-.384.16-.261.24-.72.24-1.376 0-.442-.04-.792-.12-1.048-.074-.261-.181-.448-.32-.56a.7.7 0 0 0-.464-.168ZM20.878 1.93c.475 0 .901.107 1.28.32.379.208.677.528.896.96.224.427.336.97.336 1.632 0 .661-.112 1.213-.336 1.656-.219.437-.517.765-.896.983a2.514 2.514 0 0 1-1.28.329c-.48 0-.912-.107-1.296-.32-.379-.214-.68-.537-.904-.969-.224-.437-.336-.99-.336-1.656 0-.666.112-1.215.336-1.647.224-.437.525-.76.904-.968.384-.213.816-.32 1.296-.32Zm0 1.168a.742.742 0 0 0-.48.168c-.138.112-.248.299-.328.56-.08.256-.12.606-.12 1.048 0 .656.08 1.115.24 1.376.166.256.392.384.68.384.288 0 .512-.128.672-.384.16-.261.24-.72.24-1.376 0-.442-.04-.792-.12-1.048-.075-.261-.181-.448-.32-.56a.7.7 0 0 0-.464-.168Z"
      fill="currentColor"
    />
    <path
      d="M12.104 7.73H10.51V3.656L9.287 4.85V3.386l1.424-1.384h1.393v5.727Z"
      fill="currentColor"
    />
  </svg>
);

export const RouteFromMoreThan100 = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.413 16.2c.475 0 .902.107 1.28.32.379.209.677.529.896.96.224.427.336.971.336 1.632 0 .662-.112 1.214-.336 1.657-.219.437-.517.764-.896.983a2.514 2.514 0 0 1-1.28.328c-.48 0-.912-.107-1.296-.32-.378-.214-.68-.536-.904-.968-.224-.437-.336-.99-.336-1.656 0-.667.112-1.216.336-1.648.224-.437.526-.76.904-.968.384-.213.816-.32 1.296-.32Zm0 1.168a.742.742 0 0 0-.48.168c-.138.112-.248.3-.328.56-.08.257-.12.606-.12 1.049 0 .655.08 1.114.24 1.375.166.256.392.384.68.384.288 0 .512-.128.672-.384.16-.26.24-.72.24-1.375 0-.443-.04-.792-.12-1.048-.074-.262-.181-.449-.32-.56a.7.7 0 0 0-.464-.169Z"
      fill="currentColor"
    />
    <path
      d="M4.104 22H2.51v-4.072L1.287 19.12v-1.464l1.424-1.383h1.393V22ZM13.143 22H11.55v-4.072l-1.225 1.192v-1.464l1.424-1.383h1.393V22Z"
      fill="currentColor"
    />
    <path
      d="M22.014 18a3.65 3.65 0 0 1-7.301 0v-5a3.35 3.35 0 1 0-6.7 0v1h-1.3v-1a4.65 4.65 0 0 1 9.3 0v5a2.35 2.35 0 1 0 4.7 0V0h1.3v18Z"
      fill="currentColor"
    />
  </svg>
);
